'use client';

import cn from 'classnames';
import { useState } from 'react';
import { Text } from '@/shared/ui/core';
import { UserProfile } from '@/entities/user-profile';
import { Button } from '@/shared/ui/core';
import { UserMenu } from '@/shared/ui/kit/user-menu';
import { CaretDownIcon, UserIcon } from '@phosphor-icons/react/dist/ssr';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import Icon from '../assets/icon.svg';
import { VERIFICATION_PATHNAME } from '@/shared/constants/pathnames';
import styles from './landing-logged-in-controls.module.scss';


export type ComponentProps = {
    profile: UserProfile | null;
}


export function LandingLoggedInControls ({ profile }: ComponentProps) {
    const [ isOpen, setIsOpen ] = useState(false);

    return (
        <div className={ cn(styles.root, { [styles.open]: isOpen }) }>
            <Button
                as="a"
                href={ VERIFICATION_PATHNAME }
                className={ styles.button }
                leftIcon={
                    <Icon className={ styles.icon }/>
                }
            >
                <Text
                    weight="medium"
                    className={ styles.platform }
                >
                    carriercheck® platform
                </Text>
            </Button>

            <DropdownMenu.Root
                open={ isOpen }
                onOpenChange={ setIsOpen }
                modal={ false }
            >
                <DropdownMenu.Trigger asChild>
                    <Button
                        className={ styles.user_menu_trigger }
                        variant="naked"
                        leftIcon={
                            <UserIcon size={ 20 }/>
                        }
                    >
                        <Text
                            className={ styles.name }
                        >
                            { ((profile?.first_name ?? '') + ' ' + (profile?.last_name)).trim() }
                        </Text>
                        <CaretDownIcon className={ styles.caret }/>
                    </Button>
                </DropdownMenu.Trigger>

                <UserMenu/>
            </DropdownMenu.Root>
        </div>
    );
}
